import {SAVE_REACT_TABLE_STATE} from "./types";

export default function saveReactTableState( tableId, state ){

    return {
        type: SAVE_REACT_TABLE_STATE,
        payload: {tableId, state}
    }
}
